import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, InputGroup } from "../../../UI";
import Container from "./styles2";
import mark from "./mark.png";
import Ellipse4 from "../../../assets/Ellipse4.svg";
import { useSelector } from "react-redux";
import moment from "moment";

const Jumbotron = ({ clicked }) => {
  const [text, setText] = useState("text");
  const navigate = useNavigate();
  const { tracker } = useSelector((s) => s.UserData);

  return (
    <Container>
      {clicked && tracker.length != 0 && (
        <>
          <div className="JumbotronTitleContainer">
            <div className="JumbotronTitle">
              <div className="JumbotronTitleText">
                <img
                  src={Ellipse4}
                  alt="Ellipse"
                  style={{ marginRight: -260 }}
                />
                Package movement
              </div>
            </div>
            <div className="JumbotronTitle">
              <div
                className="JumbotronTitleText2"
                style={{
                  color: "rgba(255, 255, 255, 0.6)",
                  fontWeight: "500"
                }}
              >
                Order ID: {tracker.reference}
              </div>
            </div>
            <div className="JumbotronTitle">
              <div className="JumbotronTitleAmount">
                Amt: ₦ {tracker.payment_confirmed}
              </div>
            </div>
            <div className="JumbotronTitle">
              <div
                className="JumbotronTitleText2"
                style={{
                  color: "rgba(255, 255, 255, 0.6)",
                  fontWeight: "500"
                }}
              >
                {moment(tracker.created_at).format("MMM Do YY")}
              </div>
            </div>
            <div className="JumbotronTitle">
              <div className="JumbotronTitleAmount">
                STATUS: <span style={tracker.status ==="pending"?{ color:"yellow"}:tracker.status ==="fulfilled"?{ color:"green"}:{ color:"red"}}> {tracker.status}</span>
              </div>
            </div>
          </div>
          <div className="MarkerComponent">
            {tracker.order_status.map((r) => (
              <div className="markerImage">
                <img
                  src="mark2.png"
                  style={{ marginRight: 25, height: "100%" }}
                  alt="mark"
                />

                <div
                  style={{
                    textAlign: "start",
                    marginLeft: 20,
                    textTransform: "capitalize"
                  }}
                >
                  <div>{r.status}</div>
                  <div className="markText">
                    {r.notes}
                    <br />
                    {moment(r.created_at).format("MMM Do YY,  h:mm:ss")}
                  </div>
                </div>
              </div>
            ))}
            {tracker.order_status.length > 0 && (
              <div className="markerImage">
                <img
                  src="mark3.png"
                  style={{ marginRight: 25, height: "100%" }}
                  alt="mark"
                />
              </div>
            )}
            <img
              src="backgroundImage.png"
              alt="background Image"
              style={{
                width: "50vw",
                height: "100%",
                marginTop: "-30%",
                marginRight: "-55%"
              }}
            />
          </div>
        </>
      )}
    </Container>
  );
};

export default Jumbotron;
